import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var HeartLinear = function HeartLinear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HeartLinear_svg__HeartLinear_svg__clip0_18154_91311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.045 8.123c-1.536 2.26-5.455 5.409-5.985 5.83a.094.094 0 01-.12 0c-.53-.421-4.45-3.57-5.985-5.83-1.12-1.645-1.418-3.673 0-5.073a3.662 3.662 0 015.133 0l.897.888L8 3.924l.016.014.897-.888a3.662 3.662 0 015.133 0c1.418 1.4 1.12 3.428 0 5.073z",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "HeartLinear_svg__HeartLinear_svg__clip0_18154_91311"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default HeartLinear;